type Category = "before" | "ongoing" | "ongoing1" | "ongoing2" | "ongoing3" | "after" | "etc";
export const getTipThumbnailSrc = (category: Category, id: number | string) => {
  return `/images/guidebook/tip/thumbnail/${category}/${id}.png`;
};
